import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { A11yContrastRatio } from "../../components";
import $ from "jquery";
import { getSidebarCustomize } from "../../sidebar";
/**
 * Add a `A11yContrastRatio` to a given set of settings and output a warning or error message
 * when a minimum ratio got not reached. The "Contrast ratio:" and notice is only rendered
 * to the second (`props.settings[1]`) setting.
 */ function a11yConstrastRatio(props) {
    const customize = getSidebarCustomize();
    customize.control(props.settings[1], (param)=>{
        let { container } = param;
        const root = createRoot($("<div />").addClass("customize-control-iris-contrast-ratio").appendTo(container.find(".wp-picker-holder")).get(0));
        root.render(/*#__PURE__*/ _jsx(A11yContrastRatio, {
            ...props
        }));
    });
}
export { a11yConstrastRatio };
